export const PRODUCT_UOM_CONVERSION_CONSTRAINTS = {
    // WHY: below the column's Decimal(28,9) scale, Postgres rounds the value to 0 and the ratio-positive CHECK constraint rejects it with an unhandled DB error.
    ratio: { label: 'Ratio', min: 0.000000001, minMessage: '0.000000001', max: 1_000_000_000 },
};
//# sourceMappingURL=constraints.js.map